import { Link, useNavigate, useLocation } from "react-router-dom"
import { useState, useEffect } from "react";
import { FaBox, FaWallet, FaMapMarkerAlt, FaUser, FaSignOutAlt, FaCreditCard, FaBarcode, FaPlus, FaTimes, FaBars } from 'react-icons/fa';
import Footer from "./component/Footer";

const MyWallet = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isVisible, setIsVisible] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const handleScrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
        const toggleVisibility = () => setIsVisible(window.pageYOffset > 300);
        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const navItems = [
          { icon: <FaUser size={16} />, label: "My Profile", path: "/my-profile" },
        { icon: <FaBox size={16} />, label: "My Order", path: "/my-orders" },
        // { icon: <FaWallet size={16} />, label: "My Wallet", path: "/my-wallet" },
        { icon: <FaMapMarkerAlt size={16} />, label: "My Address", path: "/my-address" },
      
    ];

    const handleLogout = () => {
        localStorage.removeItem('token');
        sessionStorage.removeItem('token');
        navigate('/user-login');
    };

    return (
        <>
            <style>{`
                .dashboard-wrapper {
                    display: flex;
                    min-height: 80vh;
                    padding: 20px;
                    gap: 20px;
                }
                .sidebar-overlay {
                    display: none;
                    position: fixed;
                    inset: 0;
                    background: rgba(0,0,0,0.45);
                    z-index: 998;
                }
                .sidebar-overlay.open { display: block; }

                .dashboard-sidebar {
                    width: 220px;
                    min-width: 220px;
                    background: #fff;
                    border-radius: 10px;
                    box-shadow: 0 2px 12px rgba(0,0,0,0.08);
                    padding: 10px 0;
                    display: flex;
                    flex-direction: column;
                    height: fit-content;
                    position: sticky;
                    top: 20px;
                }
                .sidebar-nav-item {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    padding: 14px 20px;
                    color: #444;
                    text-decoration: none;
                    font-size: 14px;
                    border-left: 3px solid transparent;
                    transition: all 0.2s ease;
                }
                .sidebar-nav-item:hover,
                .sidebar-nav-item.active {
                    background: #f5f8ff;
                    border-left-color: #007bff;
                    color: #007bff;
                }
                .sidebar-nav-item.logout {
                    color: #e53935;
                    cursor: pointer;
                    border: none;
                    background: none;
                    width: 100%;
                    text-align: left;
                    font-size: 14px;
                }
                .sidebar-nav-item.logout:hover {
                    background: #fff5f5;
                    border-left-color: #e53935;
                }
                .sidebar-divider { height: 1px; background: #f0f0f0; margin: 0; }

                .mobile-menu-btn {
                    display: none;
                    align-items: center;
                    gap: 8px;
                    background: #007bff;
                    color: #fff;
                    border: none;
                    border-radius: 8px;
                    padding: 10px 16px;
                    font-size: 14px;
                    cursor: pointer;
                    margin-bottom: 16px;
                }
                .sidebar-drawer {
                    display: none;
                    position: fixed;
                    top: 106px;
                    left: -260px;
                    width: 240px;
                    height: 100%;
                    background: #fff;
                    z-index: 999;
                    box-shadow: 4px 0 20px rgba(0,0,0,0.15);
                    flex-direction: column;
                    transition: left 0.3s ease;
                    overflow-y: auto;
                    padding-top: 0;
                }
                .sidebar-drawer.open { left: 0; }
                .drawer-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 16px 20px;
                    border-bottom: 1px solid #f0f0f0;
                    margin-bottom: 8px;
                    position: sticky;
                    top: 0;
                    background: #fff;
                    z-index: 1;
                }
                .drawer-header span { font-weight: 600; font-size: 15px; color: #333; }
                .sidebar-drawer-close {
                    background: none;
                    border: none;
                    font-size: 18px;
                    cursor: pointer;
                    color: #555;
                    padding: 0;
                    display: flex;
                    align-items: center;
                }

                .dashboard-content { flex: 1; min-width: 0; }

                /* Wallet Cards */
                .wallet-section { margin-bottom: 24px; }
                .wallet-section-title {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 12px;
                }
                .wallet-section-title h3 {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    font-size: 16px;
                    font-weight: 600;
                    color: #333;
                    margin: 0;
                }
                .wallet-card {
                    background: #fff;
                    border-radius: 10px;
                    box-shadow: 0 2px 10px rgba(0,0,0,0.07);
                    border: 1px solid #f0f0f0;
                    padding: 20px 24px;
                }
                .wallet-empty-row {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 12px;
                }
                .wallet-empty-left {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                }
                .wallet-empty-text {
                    color: #888;
                    font-size: 15px;
                    margin: 0;
                }
                .add-btn {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    background: transparent;
                    border: 1px solid #28a745;
                    color: #28a745;
                    border-radius: 6px;
                    padding: 6px 14px;
                    font-size: 13px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    white-space: nowrap;
                }
                .add-btn:hover { background: #28a745; color: #fff; }
                .add-btn-blue {
                    border-color: #007bff;
                    color: #007bff;
                }
                .add-btn-blue:hover { background: #007bff; color: #fff; }

                @media (max-width: 768px) {
                    .dashboard-wrapper { padding: 12px; flex-direction: column; gap: 0; }
                    .dashboard-sidebar { display: none; }
                    .mobile-menu-btn { display: flex; }
                    .sidebar-drawer { display: flex; }
                    .wallet-card { padding: 16px; }
                    .wallet-empty-row { flex-wrap: wrap; gap: 10px; }
                    .add-btn { width: 100%; justify-content: center; }
                }
            `}</style>

            <main className="main__content_wrapper">

                {/* Breadcrumb */}
                 <section className="breadcrumb__section d-none" >
                    <div className="container">
                        <div className="row row-cols-1">
                            <div className="col">
                                <div className="breadcrumb__content text-left">
                                    <h1 className="breadcrumb__content--title text-dark mb-25">User Dashboard</h1>
                                    <ul className="breadcrumb__content--menu d-flex justify-content-left">
                                        <li className="breadcrumb__content--menu__items"><Link className="text-dark" to="/">Home</Link></li>
                                        <li className="breadcrumb__content--menu__items"><Link className="text-dark" to="/user-login">Login</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Overlay */}
                <div className={`sidebar-overlay ${sidebarOpen ? 'open' : ''}`} onClick={() => setSidebarOpen(false)} />

                {/* Mobile Drawer */}
                <div className={`sidebar-drawer ${sidebarOpen ? 'open' : ''}`}>
                    <div className="drawer-header">
                        <span>My Account</span>
                        <button className="sidebar-drawer-close" onClick={() => setSidebarOpen(false)}>
                            <FaTimes />
                        </button>
                    </div>
                    {navItems.map((item) => (
                        <Link
                            key={item.path}
                            to={item.path}
                            className={`sidebar-nav-item ${location.pathname === item.path ? 'active' : ''}`}
                            onClick={() => setSidebarOpen(false)}
                        >
                            {item.icon} {item.label}
                        </Link>
                    ))}
                    <div className="sidebar-divider" />
                    <button className="sidebar-nav-item logout" onClick={handleLogout}>
                        <FaSignOutAlt size={16} /> Logout
                    </button>
                </div>

                <div className="container-fluid">
                    <div className="dashboard-wrapper">

                        {/* Desktop Sidebar */}
                        <div className="dashboard-sidebar">
                            {navItems.map((item, idx) => (
                                <div key={item.path}>
                                    <Link
                                        to={item.path}
                                        className={`sidebar-nav-item ${location.pathname === item.path ? 'active' : ''}`}
                                    >
                                        {item.icon} {item.label}
                                    </Link>
                                    {idx < navItems.length - 1 && <div className="sidebar-divider" />}
                                </div>
                            ))}
                            <div className="sidebar-divider" />
                            <button className="sidebar-nav-item logout" onClick={handleLogout}>
                                <FaSignOutAlt size={16} /> Logout
                            </button>
                        </div>

                        {/* Main Content */}
                        <div className="dashboard-content">

                            {/* Mobile menu btn */}
                            <button className="mobile-menu-btn" onClick={() => setSidebarOpen(true)}>
                                <FaBars size={16} /> Menu
                            </button>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

                                {/* Debit & Credit Card */}
                                <div className="wallet-section">
                                    <div className="wallet-section-title">
                                        <h3>
                                            <FaCreditCard size={18} color="#007bff" />
                                            Debit and Credit Card
                                        </h3>
                                    </div>
                                    <div className="wallet-card">
                                        <div className="wallet-empty-row">
                                            <div className="wallet-empty-left">
                                                <FaCreditCard size={22} color="#007bff" />
                                                <p className="wallet-empty-text">No debit/credit card saved</p>
                                            </div>
                                            <button className="add-btn add-btn-blue">
                                                <FaPlus size={12} /> Add Card
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* UPI */}
                                <div className="wallet-section">
                                    <div className="wallet-section-title">
                                        <h3>
                                            <FaBarcode size={18} color="#28a745" />
                                            UPI
                                        </h3>
                                    </div>
                                    <div className="wallet-card">
                                        <div className="wallet-empty-row">
                                            <div className="wallet-empty-left">
                                                <FaBarcode size={22} color="#28a745" />
                                                <p className="wallet-empty-text">No UPI ID saved</p>
                                            </div>
                                            <button className="add-btn">
                                                <FaPlus size={12} /> Add UPI
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </main>

            <Footer />

            <button
                onClick={handleScrollTop}
                style={{
                    position: 'fixed', bottom: '30px', right: '30px', width: '46px', height: '46px',
                    borderRadius: '50%', backgroundColor: '#ceb256', color: '#fff', border: 'none',
                    zIndex: 1000, cursor: 'pointer', display: isVisible ? 'flex' : 'none',
                    alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" height="22" width="22" viewBox="0 0 512 512" fill="none" stroke="currentColor" strokeWidth="48" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M112 244l144-144 144 144" />
                    <path d="M256 120v292" />
                </svg>
            </button>
        </>
    );
};

export default MyWallet;